var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "t-search t-pad--t-sm t-pad--b-sm t-pad--l-st t-pad--r-st" },
    [
      _c("t-input", {
        attrs: {
          size: "large",
          type: "search",
          name: "app-search",
          fluid: "",
          autofocus: true,
          focus: true,
          loading: !_vm.$isEmpty(_vm.resultSet) && _vm.loading,
          placeholder: _vm.$t("search.videos_placeholder"),
          label: _vm.hideLabel ? "" : _vm.$t("home.select_video.title"),
        },
        on: {
          input: function ($event) {
            return _vm.searchFn()
          },
        },
        model: {
          value: _vm.search,
          callback: function ($$v) {
            _vm.search = $$v
          },
          expression: "search",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }